import { initDealsCarousel } from './components/Carousel/initDealsCarousel';
import { initializeFindStorePrompt } from './utilities/findStore';

(() => {
  if (drupalSettings.featureFlags.deals_store_requirement) {
    if (drupalSettings.hasStoreDetails) {
      const { heroDeals } = drupalSettings.deals;
      initDealsCarousel(heroDeals);
    } else {
      initializeFindStorePrompt();
    }
  } else {
    const { heroDeals } = drupalSettings.deals;
    initDealsCarousel(heroDeals);
  }
})();
